'use strict';


(function () {
    if (typeof window.CustomEvent === "function") return false;

    function CustomEvent(event, params) {
        params = params || {bubbles: false, cancelable: false, detail: null};
        var evt = document.createEvent('CustomEvent');
        evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
        return evt;
    }

    window.CustomEvent = CustomEvent;
})();

export function trigger(type, detail) {
    this.dispatchEvent(new CustomEvent(type, {
        bubbles: true,
        detail: detail
    }));
}

function getListenType(eventType) {
    switch (eventType) {
        case 'mouseenter':
            return 'mouseover';
        case 'mouseleave':
            return 'mouseout';
        default:
            return eventType;
    }
}

/**
 * @deprecated Use delegate
 * @param eventType
 * @param selector
 * @param listener
 * @param options
 * @returns {{unlisten(): void}}
 */
export function listen(eventType, selector, listener, options) {

    const node = this;
    const listenTo = getListenType(eventType);

    const handler = function (e) {
        var target = e.target;
        while (target && target !== this) {
            if (typeof target.matches === 'function' && target.matches(selector)) {
                switch (eventType) {
                    case 'mouseenter':
                    case 'mouseleave':
                        var related = e.relatedTarget !== undefined ? e.relatedTarget : e.fromElement;
                        target = target.closest(selector);
                        if (!target) {
                            return;
                        }
                        while (related && related !== target && related !== document) {
                            related = related.parentNode;
                        }
                        if (related === target) {
                            return;
                        }
                        listener.apply(target, arguments);
                        break;
                    default:
                        listener.apply(target, arguments);
                }
                break;
            }
            target = target.parentNode;
        }
    };

    node.addEventListener(listenTo, handler, options);

    return {
        unlisten() {
            node.removeEventListener(listenTo, handler, options);
        }
    };
}

export function delegate(selector, listener) {
    return function handler(e) {
        let target = e.target;
        while (target && target !== this) {
            if (target.matches(selector)) {
                listener.apply(target, arguments);
                break;
            }
            target = target.parentNode;
        }
    };
}

export function wait(eventType) {
    const node = this;
    let handler = null;

     const promise = new Promise(function (resolve) {
        handler = function (e) {
            handler = null;
            resolve(e);
        };
        node.addEventListener(eventType, handler);
    });

    return {
        promise: promise,
        cancel: function () {
            if (handler) {
                node.removeEventListene(eventType, handler);
            }
        }
    };
}
